import { Moment } from '@shared/app/scripts/vendor/moment';
import { PlainTemplateFilters } from '@core/app/scripts/services/plain-template-filters';
import { SettingsManager } from '@shared/app/scripts/services/settings-manager';
import { TimeKeeper } from '@core/app/scripts/services/time-keeper';
import { Utility } from '@core/app/scripts/services/utility';
import { SalesCalculations } from '@shared/app/scripts/services/sales-calculations';
import { FashionCheque } from '@shared/app/scripts/services/fashion-cheque';

const Mustache = require('mustache');

export class HandleTemplate {
  constructor(
    private $currencyFilter: ng.IFilterCurrency,
    private $injector: ng.IInjectStatic,
    private $q: ng.IQService,
    private $translate: ng.translate.ITranslateService,
    private dateFilter: ng.IFilterDate,
    private fashionCheque: FashionCheque,
    private moment: Moment,
    private numberFilter: ng.IFilterNumber,
    private plainTemplateFilters: PlainTemplateFilters,
    private settingsManager: SettingsManager,
    private timeKeeper: TimeKeeper,
    private utility: Utility,
    private salesCalculations: SalesCalculations,
    private parser,
  ) {}

  addPrinterHeaders = (template: string) => {
    const setEnconding =
      '{{#filters.charCode}}0x1B,0x74,0x28{{/filters.charCode}}';

    switch (this.settingsManager.settings.printerType) {
      case 'tm88iv':
        return `{{#filters.charCode}}0x1B::M1,0x1D::(L,0x06,0x00::0E00,0x01,0x01,0x1B::E,0x01{{/filters.charCode}}
${setEnconding}
${template}`;
      case 'tm88iii':
        return `{{#filters.charCode}}0x1B::M1,0x1C::p,0x01,0x00,0x1B::E1{{/filters.charCode}}
${setEnconding}
${template}`;
      case 'tm70':
        return `{{#filters.charCode}}0x1B::@,0x1B::M1,0x1D::(L,0x06,0x00::0E00,0x01,0x01,0x1B::E,0x01{{/filters.charCode}}
${setEnconding}
${template}`;
      case 'nxp':
        return `{{#filters.charCode}}0x1C::p,0x01,0x00,0x1B::E1{{/filters.charCode}}
${setEnconding}
${template}`;
      case 'tm20':
      default:
        return `{{#filters.charCode}}0x1B,0x45,0x01{{/filters.charCode}}
${setEnconding}
${template}`;
    }
  };

  storedTemplates = {
    // used from code
    'transit.mustache': {
      content: require('../../../../templates/transit.mustache'),
    },
    // used from code
    'transit_html.mustache': {
      content: require('../../../../templates/transit_html.mustache'),
    },
    // used from code
    'coupon-laser-printer_html.mustache': {
      content: require('../../../../templates/coupon-laser-printer_html.mustache'),
    },
    // used from code
    'coupon-plain.mustache': {
      content: require('../../../../templates/coupon-plain.mustache'),
    },
    // used from code
    'eos.mustache': {
      content: require('../../../../templates/eos.mustache'),
    },
    // used from code
    'eos_html.mustache': {
      content: require('../../../../templates/eos_html.mustache'),
    },
  };

  // TODO remove the methods and clean up the calls
  getNames = () => [
    {
      _id: 'receipt-tm88iv-plain.mustache',
      name: 'Receipt - TM88IV Plain',
    },
    {
      _id: 'receipt-tm20-plain.mustache',
      name: 'Receipt - TM20 Plain',
    },
    {
      _id: 'receipt-tm88iii-plain.mustache',
      name: 'Receipt - TM88III Plain',
    },
    {
      _id: 'receipt-tm70-plain.mustache',
      name: 'Receipt - TM70 Plain',
    },
  ];

  renderReceipt = (transaction, reprint) => {
    const container = {
      transactions: angular.copy(transaction),
      printDiscountReason:
        this.settingsManager.settings.displayAndPrintDiscountReason,
      settings: {
        footer: this.settingsManager.settings.additionalPrintInfo?.receipt,
        loyaltyRule:
          this.settingsManager.settings.loyalty?.calculatePointsPerReceipt,
        receiptPrintpoints:
          this.settingsManager.settings.loyalty?.printPointsOnReceipt,
        extended: this.settingsManager.settings.pos?.extendedReceipt,
        vatHigh: this.settingsManager.settings.vat?.highvalue,
        vatLow: this.settingsManager.settings.vat?.lowvalue,
        vatZero: this.settingsManager.settings.vat?.zerovalue,
      },
      paymentsList: this.utility.objectToArray(transaction.payments),
      customerName: this.salesCalculations.customerName(transaction),
      finalTotalDiscount: this.salesCalculations.totalDiscount(transaction),
      total: this.salesCalculations.total(transaction),
      changeAbsolute: this.salesCalculations.changeAbsolute(transaction),
      vatBaseHigh: transaction.vat?.hightotal - transaction.vat?.highamount,
      vatBaseLow: transaction.vat?.lowtotal - transaction.vat?.lowamount,
      receipt: this.salesCalculations.getExpandedReceiptInfo(transaction),
      articlesHaveDiscount:
        this.salesCalculations.hasDiscountedArticles(transaction),
    };

    if (reprint) {
      container.reprint = true;
    }

    const receiptHtml = require('../../../../templates/receipt-html.mustache'),
      receiptPlain = require('../../../../templates/receipt-plain.mustache');

    let template = '';

    if (this.settingsManager.settings.printer === 'browser') {
      template = receiptHtml;
    } else {
      template = this.addPrinterHeaders(receiptPlain);
    }

    if (container.receipt?.length) {
      for (const line of container.receipt) {
        if (line.couponNr && this.fashionCheque.validateCode(line.couponNr)) {
          line.couponNr =
            line.couponNr.replace(/\d{4}$/, '****') +
            '\n' +
            this.$translate.instant('balance') +
            ': ' +
            line.couponBalance;
        }
      }
    }

    return this.renderStaticTemplate(template, container, undefined, undefined);
  };

  // TODO replace "container" with transaction
  renderWithdrawal = (container) => {
    const withdrawalHtml = require('../../../../templates/withdrawal-html.mustache'),
      withdrawalPlain = require('../../../../templates/withdrawal-plain.mustache');

    let template;

    if (this.settingsManager.settings.printer === 'browser') {
      template = withdrawalHtml;
    } else {
      template = this.addPrinterHeaders(withdrawalPlain);
    }

    return this.renderStaticTemplate(template, container, undefined, undefined);
  };

  /**
   * @name v6CoreModule.handleTemplate#renderStaticTemplate
   * @methodOf v6CoreModule.customer
   *
   * @description
   * This method renders a template by providing the method with the raw template
   * text and a container object
   * @param {string} template The template text
   * @param {object} container Example: object = {transaction: pos.transaction, config: pos.config};
   * @param {string} type the type of template: html or plain
   * @param {array} requiredServices array of required services to render the template
   */
  renderStaticTemplate = (template, container, type, requiredServices) => {
    let i;
    container = angular.copy(container);

    container.filters = this.filters(type);
    container.exp = this.expressions();

    for (i in requiredServices) {
      this.addServiceFunctionTo(requiredServices[i], container);
    }

    const result = Mustache.render(template, container);
    return result;
  };

  /**
   * @name v6CoreModule.handleTemplate#renderObject
   * @methodOf v6CoreModule.customer
   *
   * @description
   * Render the result, based on template and data object. Expected object is based on the the template's object_type
   * @param {string} templateID
   * @param {object} container Example: object = {transaction: pos.transaction, config: pos.config};
   * @param {function} callback function that will recieve the the rendered String
   * @param {function} error function that will be called in case of error
   */
  renderObject = (templateID, container, callback, error) => {
    const deferred = this.$q.defer(),
      template = this.storedTemplates[templateID];

    deferred.promise.then(callback, error);

    if (template) {
      try {
        deferred.resolve(
          this.renderStaticTemplate(
            template.content,
            container,
            template.type,
            template.requires,
          ),
        );
      } catch (error) {
        deferred.reject('rendering failed');
      }
    } else {
      deferred.reject('No template');
    }

    return deferred.promise;
  };

  filters = (type) => {
    const padding = (text, render, rl) => {
      let i;
      const a = text.split('::');
      const l = a.length;
      if (l < 2) {
        return 'Missing :: on padding' + rl;
      }
      const n = a[l - 1];
      const subl = a[l - 1].length + 2;
      let s = render(text.slice(0, -subl)).slice(0, n);
      let char = ' ';
      if (type == 'HTML') {
        char = '&nbsp;';
      }
      if (n) {
        if (rl == 'R') {
          for (i = s.length; i < n; i++) {
            s += char;
          }
        } else {
          for (i = s.length; i < n; i++) {
            s = char + s;
          }
        }
      }
      return s;
    };

    const cchar = (text) => {
      const a = text.split(',');

      let s = '';
      let a2;

      for (let i = 0; i < a.length; i++) {
        a2 = a[i].split('::');
        s += String.fromCharCode(a2[0]);
        if (a2[1]) {
          s += a2[1];
        }
      }
      return s;
    };

    const generateBarcode = (text, render) => {
      const controlCharacters = '0x1D::hP,0x1D::w,0x02,0x1D::k,0x04';
      if (this.settingsManager.settings.printer === 'localThermal') {
        return `</pre><p class="barcode">*${render(
          text,
        )}*</p><pre class="receipt">`;
      } else {
        return `${cchar(controlCharacters, render)}${render(text)}${cchar(
          '0x00',
          render,
        )}`;
      }
    };

    const filters = {
      fixed: () => {
        return (text, render) => this.utility.round2(render(text)).toFixed(2);
      },
      translate: () => {
        return (text, render) => {
          const t = text.split('::');
          if (t[1]) {
            return this.$translate.instant(render(t[0]), t[1]);
          }
          return this.$translate.instant(render(text));
        };
      },
      equals: () => {
        return (text, render) => {
          const t = text.split('::');
          if (t[1]) {
            return render(t[0]) == t[1];
          }
          return render(t[0]) === '';
        };
      },
      paddingRight: () => {
        return (text, render) => padding(text, render, 'R');
      },
      paddingLeft: () => {
        return (text, render) => padding(text, render, 'L');
      },
      charCode: () => {
        return this.settingsManager.settings.printer === 'localThermal'
          ? angular.noop
          : cchar;
      },
      absolute: () => {
        return (text, render) => Math.abs(render(text));
      },
      uppercase: () => {
        return (text, render) => render(text).toUpperCase();
      },
      lowercase: () => {
        return (text, render) => render(text).toLowerCase();
      },
      now: () => {
        return (text) => this.dateFilter(this.timeKeeper.getLocalDate(), text);
      },
      shortDate: () => {
        return (text, render) => {
          return this.dateFilter(this.moment(render(text)).toDate(), 'short');
        };
      },
      logo: () => {
        return () => {
          if (
            this.settingsManager.settings.printLogoOnReceipt &&
            this.settingsManager.settings.logoUrl &&
            this.settingsManager.settings.logoUrl.medium
          ) {
            return (
              '<img src="' + this.settingsManager.settings.logoUrl.medium + '">'
            );
          } else {
            return '';
          }
        };
      },
      generateBarcode: () => {
        return (text, render) => generateBarcode(text, render);
      },
      currency: () => {
        return (text, render) => {
          switch (this.settingsManager.settings.printerType) {
            case 'tm88iv':
            case 'tm88iii':
            case 'tm70':
            case 'nxp':
              return this.numberFilter(render(text), 2);
            case 'tm20':
            default:
              return this.$currencyFilter(render(text));
          }
        };
      },
    };

    if (type !== 'HTML') {
      filters.appendNewLine = () => {
        return (text, render) =>
          this.plainTemplateFilters.appendNewLine(render(text));
      };
      filters.conditionalBlock = (test) => {
        return (text, render) => {
          return this.plainTemplateFilters.conditionalBlock(render(text));
        };
      };
    }

    return filters;
  };

  expressions = () => {
    const sum = () => (text, render) => {
      //{{#sum}}a,b,c{{/sum}}
      //{{#sum}}{{#yar}}{{cash}}{{/yar}}{{/sum}}
      const t = text.replace('{{/', ',{{/');
      const s = render(t);
      const a = s.split(',');
      let r = 0;
      let num;
      for (const i in a) {
        num = Number(a[i]);
        if (!isNaN(num)) {
          r += num;
        }
      }
      return r;
    };
    const innerFirst = (text, render) => {
      //{{#innerFirst}}{{yar.{{ref}} }}{{/innerFirst}}
      const i = text.lastIndexOf('{{');
      if (i == -1) {
        return text;
      }
      const j = text.indexOf('}}', i);
      const s = render(text.substring(i, j + 2));
      const r = text.substring(0, i) + s + text.slice(j + 2);
      return innerFirst(r, render);
    };
    const avg = () => (text, render) => {
      const t = text.replace('{{/', ',{{/');
      const s = render(t);
      const a = s.split(',');
      let r = 0;
      let num;
      let l = 0;
      for (const i in a) {
        //1,2,3," "
        if (a[i].trim() === '') {
          continue;
        }
        num = Number(a[i]);
        if ((num || num === 0) && !isNaN(num)) {
          r += num;
          l++;
        }
      }
      if (l === 0) {
        return 0;
      }
      return r / l;
    };
    const count = () => (text, render) => {
      const name = text.replace('{{', '').replace('}}', '');
      return render('{{#' + name + '}}a{{/' + name + '}}').length;
    };
    const formula = () => (value, render) => {
      value = render(value);
      try {
        value = this.parser.evaluate(value);
      } catch (err) {
        value = 0;
      }
      return value;
    };
    return {
      sum: sum,
      avg: avg,
      count: count,
      formula: formula,
      innerFirst: () => {
        return innerFirst;
      },
    };
  };

  //call this once the template itself is loaded. Other handleTemplate can be overwritten
  addServiceFunctionTo = (requiredObject, container) => {
    const f = requiredObject.func;
    //hack-resistant
    if (f.indexOf('$') != -1) {
      return;
    }
    if (f == 'apply') {
      return;
    }
    const service = this.$injector.get(requiredObject.service);
    if (requiredObject.render) {
      //renders text, then passes it to the function
      container[requiredObject.ref] = () => (text, render) =>
        service[f](render(text));
    } else {
      container[requiredObject.ref] =
        () =>
        //runs the function on the object, then renders text
        (text, render) => {
          service[f](this);
          return render(text);
        };
    }
  };

  isStored = (templateID) => {
    if (this.storedTemplates[templateID]) {
      return true;
    }
    return false;
  };
}

/**
 * @ngdoc service
 * @name v6CoreModule.handleTemplate
 * @description
 * A service for rendering Mustache templates
 */
angular
  .module('posApp')
  .service(
    'handleTemplate',
    (
      $currencyFilter: ng.IFilterCurrency,
      $injector: ng.IInjectStatic,
      $q: ng.IQService,
      translate: ng.translate.ITranslateService,
      dateFilter: ng.IFilterDate,
      moment: Moment,
      fashionCheque: FashionCheque,
      numberFilter: ng.IFilterNumber,
      plainTemplateFilters: PlainTemplateFilters,
      settingsManager: SettingsManager,
      timeKeeper: TimeKeeper,
      utility: Utility,
      salesCalculations: SalesCalculations,
      parser,
    ) => {
      return new HandleTemplate(
        $currencyFilter,
        $injector,
        $q,
        translate,
        dateFilter,
        fashionCheque,
        moment,
        numberFilter,
        plainTemplateFilters,
        settingsManager,
        timeKeeper,
        utility,
        salesCalculations,
        parser,
      );
    },
  );
